(function () {
  'use strict';

  var questions = [
    {key: 'decision', type: 'long', required: true, title: 'What made you decide to try TheraBrush?', hint: 'Please explain your story, situation, thinning type, and why you decided to try.'},
    {key: 'noticing', type: 'multi', required: true, title: 'What were you noticing? Select all that apply.', choices: ['More hair in my brush or shower', 'My part looked wider', 'My ponytail felt thinner', 'I could see more scalp at my crown', 'Thinning around my hairline or temples', 'Patches of hair loss', 'More breakage than shedding', 'I bought it for someone else', 'Other']},
    {key: 'story', type: 'multi', required: true, title: 'Which of these are part of your story? Select all that apply.', choices: ['Perimenopause', 'Menopause or post-menopause', 'PCOS', 'GLP-1 medication (Ozempic, Wegovy, others)', 'Recent significant weight loss', 'After pregnancy (post-partum)', 'AGA (Female pattern hair loss)', 'A stressful period or illness', 'A thyroid or iron issue', 'None of these', 'I am not sure', 'Other'], exclusive: ['None of these', 'I am not sure']},
    {key: 'diagnosis', type: 'multi', required: true, title: 'Has a doctor or dermatologist told you what type of hair loss you have? Select all that apply.', choices: ['Female pattern hair loss or AGA', 'Telogen effluvium', 'Alopecia areata', 'Another diagnosis', 'I saw a clinician but do not know what they called it', 'I have not been diagnosed', 'Prefer not to say'], exclusive: ['I have not been diagnosed', 'Prefer not to say']},
    {key: 'tried', type: 'multi', required: true, title: 'Before buying TheraBrush, what had you already tried to grow your hair or slow the loss? Select all that apply.', choices: ['Minoxidil', 'Another prescription treatment', 'Hair vitamins or supplements', 'Scalp oils or serums', 'A red-light cap, comb, or other device', 'Hair fibers, extensions, a topper, or a wig', 'A dermatologist or hair clinic', 'Nothing yet', 'Other'], exclusive: ['Nothing yet']},
    {key: 'frustration', type: 'single', required: true, title: 'What was most frustrating about the options you tried before?', choices: ['I did not see the hair growth I wanted', 'They were hard to keep up with', 'They irritated my scalp', 'I worried about side effects', 'They cost too much', 'I could not tell whether they were working', 'I still did not know what was causing my hair loss', 'I had not tried anything before TheraBrush', 'Other']},
    {key: 'hope', type: 'long', required: true, title: 'What were you hoping TheraBrush would help with most?'},
    {key: 'worthTrying', type: 'long', required: true, title: 'What made TheraBrush feel worth trying?'},
    {key: 'almostStopped', type: 'long', required: false, title: 'What, if anything, almost stopped you from ordering?'},
    {key: 'biggestConcern', type: 'single', required: true, title: 'Which concern was the biggest?', choices: ['I was not sure it would work for my kind of hair loss', 'I did not trust the hair-growth claims', 'I wanted better proof or reviews', 'The price', 'I was not sure I would use it consistently', 'I was not sure it would work with my hair type or hairstyle', 'I had questions about comfort or safety', 'I was not clear on the guarantee', 'I had no major concern', 'Other']},
    {key: 'orderReason', type: 'long', required: true, title: 'What finally made you place the order?'},
    {key: 'stillWishKnew', type: 'long', required: false, title: 'What do you still wish you knew about using TheraBrush for your hair?'},
    {key: 'orderNumber', type: 'text', required: true, title: 'What is your order number?', hint: 'Find it in your order confirmation email (for example, #1234). We use it to match your survey to your order for the $10 refund.'}
  ];

  function randomId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    var bytes = new Uint8Array(20);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, function (n) { return n.toString(16).padStart(2, '0'); }).join('');
  }

  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var welcome = root.querySelector('[data-tbcs-welcome]');
    var screen = root.querySelector('[data-tbcs-question-screen]');
    var scroll = root.querySelector('[data-tbcs-scroll]');
    var progress = root.querySelector('[data-tbcs-progress]');
    var progressLabel = root.querySelector('[data-tbcs-progress-label]');
    var progressFill = root.querySelector('[data-tbcs-progress-fill]');
    var number = root.querySelector('[data-tbcs-question-number]');
    var title = root.querySelector('[data-tbcs-question-title]');
    var hint = root.querySelector('[data-tbcs-question-hint]');
    var answerBox = root.querySelector('[data-tbcs-answer]');
    var error = root.querySelector('[data-tbcs-error]');
    var status = root.querySelector('[data-tbcs-status]');
    var next = root.querySelector('[data-tbcs-next]');
    var state = {index: -1, startedAt: Date.now(), answers: {}, requestId: randomId(), pendingNonce: '', timer: null, pollTimer: null};

    function render() {
      var index = state.index;
      var question = questions[index];
      welcome.hidden = true;
      screen.hidden = false;
      progress.hidden = false;
      status.hidden = true;
      error.hidden = true;
      number.textContent = 'Question ' + (index + 1) + ' of ' + questions.length;
      progressLabel.textContent = number.textContent;
      progressFill.style.width = Math.round(((index + 1) / questions.length) * 100) + '%';
      title.textContent = question.title;
      title.id = 'tbcs-question-' + root.id;
      title.tabIndex = -1;
      hint.textContent = question.hint || (question.type === 'multi' ? 'Choose all that apply.' : '');
      hint.hidden = !hint.textContent;
      answerBox.replaceChildren();
      var previous = state.answers[question.key];

      if (question.type === 'long' || question.type === 'text') {
        var field = document.createElement(question.type === 'long' ? 'textarea' : 'input');
        if (question.type === 'text') field.type = 'text';
        field.className = question.type === 'long' ? 'tbcs__textarea' : 'tbcs__text';
        field.setAttribute('aria-labelledby', title.id);
        field.autocomplete = 'off';
        field.maxLength = question.type === 'long' ? 2500 : 40;
        field.value = previous || '';
        if (question.key === 'orderNumber') field.placeholder = '#12345';
        answerBox.appendChild(field);
      } else {
        var list = document.createElement('div');
        list.className = 'tbcs__choices';
        list.setAttribute('role', 'group');
        list.setAttribute('aria-labelledby', title.id);
        question.choices.forEach(function (choice) {
          var label = document.createElement('label');
          label.className = 'tbcs__choice';
          var input = document.createElement('input');
          input.type = question.type === 'multi' ? 'checkbox' : 'radio';
          input.name = 'tbcs-' + question.key;
          input.value = choice;
          input.checked = question.type === 'multi' ? Array.isArray(previous) && previous.indexOf(choice) >= 0 : previous === choice;
          var labelText = document.createElement('span');
          labelText.textContent = choice;
          label.appendChild(input);
          label.appendChild(labelText);
          list.appendChild(label);
        });
        if (question.exclusive) {
          list.addEventListener('change', function (event) {
            if (!event.target.checked) return;
            var exclusive = question.exclusive.indexOf(event.target.value) >= 0;
            list.querySelectorAll('input:checked').forEach(function (input) {
              if (input !== event.target && (exclusive || question.exclusive.indexOf(input.value) >= 0)) input.checked = false;
            });
          });
        }
        answerBox.appendChild(list);
      }
      next.textContent = index === questions.length - 1 ? 'Submit survey' : 'Continue';
      next.disabled = false;
      scroll.scrollTop = 0;
      title.focus({preventScroll: true});
    }

    function saveCurrent(validate) {
      var question = questions[state.index];
      var value;
      if (question.type === 'long' || question.type === 'text') value = answerBox.querySelector('textarea, input').value.trim();
      else if (question.type === 'multi') value = Array.from(answerBox.querySelectorAll('input:checked'), function (input) { return input.value; });
      else value = (answerBox.querySelector('input:checked') || {}).value || '';
      if (validate && question.required && (!value || (Array.isArray(value) && !value.length))) {
        error.textContent = 'Please answer this question to continue.';
        error.hidden = false;
        return false;
      }
      if (validate && question.key === 'orderNumber' && !/^#?\s*[a-z0-9-]{3,32}$/i.test(value)) {
        error.textContent = 'Enter the order number from your confirmation email.';
        error.hidden = false;
        return false;
      }
      state.answers[question.key] = value;
      error.hidden = true;
      return true;
    }

    function fail(message) {
      clearTimeout(state.timer);
      clearTimeout(state.pollTimer);
      state.pendingNonce = '';
      next.disabled = false;
      status.textContent = message;
      status.hidden = false;
      scroll.scrollTop = scroll.scrollHeight;
    }

    function submit() {
      if (!root.dataset.receiverUrl) {
        fail('The survey is not connected yet. Please try again later.');
        return;
      }
      state.pendingNonce = randomId().replace(/[^a-f0-9-]/gi, '');
      var request = JSON.stringify({
        requestId: state.requestId,
        nonce: state.pendingNonce,
        startedAt: state.startedAt,
        honey: '',
        answers: state.answers
      });
      next.disabled = true;
      status.textContent = 'Saving your answers…';
      status.hidden = false;
      state.timer = setTimeout(function () {
        fail('We could not confirm the save. Please try again; retrying will not create a second response.');
      }, 45000);
      fetch(root.dataset.receiverUrl, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        body: new URLSearchParams({payload: request})
      }).then(checkReceipt, checkReceipt);
    }

    function checkReceipt() {
      if (!state.pendingNonce) return;
      var script = document.createElement('script');
      script.src = root.dataset.receiverUrl + '?receipt=' + encodeURIComponent('TBC-' + state.requestId) + '&_=' + Date.now();
      script.async = true;
      script.onload = script.onerror = function () {
        script.remove();
        if (state.pendingNonce) state.pollTimer = setTimeout(checkReceipt, 1800);
      };
      document.head.appendChild(script);
    }

    window.tbCustomSurveyReceiptCallback = function (data) {
      if (!state.pendingNonce || !data || !data.exists || data.receipt !== 'TBC-' + state.requestId) return;
      clearTimeout(state.timer);
      clearTimeout(state.pollTimer);
      state.pendingNonce = '';
      try {
        sessionStorage.setItem('tbCustomSurveyReceipt', JSON.stringify({receipt: data.receipt, order: state.answers.orderNumber, at: Date.now()}));
      } catch (_error) {}
      window.location.assign(root.dataset.thanksPath || '/pages/tb-custom-survey-thank-you');
    };

    root.querySelector('[data-tbcs-start]').addEventListener('click', function () {
      state.startedAt = Date.now();
      state.index = 0;
      render();
    });
    root.querySelector('[data-tbcs-back]').addEventListener('click', function () {
      saveCurrent(false);
      if (state.index === 0) {
        state.index = -1;
        welcome.hidden = false;
        screen.hidden = true;
        progress.hidden = true;
        return;
      }
      state.index -= 1;
      render();
    });
    next.addEventListener('click', function () {
      if (!saveCurrent(true)) return;
      if (state.index < questions.length - 1) {
        state.index += 1;
        render();
      } else {
        submit();
      }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('.tbcs__text')) {
        event.preventDefault();
        next.click();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.tbcs').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
